module.exports = __webpack_public_path__ + "img/dest_marker.26f944ab.svg";